import { ADDABLE_FILE_PROVIDERS_LIST, FileProviderType } from '../utils/constants';

export const NOT_ADDABLE_ERROR = 'file provider is not addable';

export default function isFileProviderAddable(provider: FileProviderType): boolean {
    return ADDABLE_FILE_PROVIDERS_LIST.indexOf(provider) > -1;
}
